var _defs, _circle, _circle2, _circle3, _line;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNeutralUnselected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:#333;}.cls-3{fill:none;stroke:#e74d56;stroke-linecap:round;stroke-miterlimit:10;stroke-width:3px;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 40,
    y1: 80,
    x2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fcbd01",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#fcbd01",
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#fcbd01",
    stopOpacity: 0.68
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#fcbd01",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fcbd01"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 40,
    cy: 40,
    r: 40
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 28,
    cy: 34.75,
    r: 2.75
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 52,
    cy: 34.75,
    r: 2.75
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 28.5,
    y1: 50,
    x2: 51.5,
    y2: 50
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeutralUnselected);
export default __webpack_public_path__ + "static/media/neutralUnselected.4be57d2362fddceb8059b1d096fa492c.svg";
export { ForwardRef as ReactComponent };